var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{key:`${_vm.alternativeId}${_vm.subOptionId}`,class:_vm.getLabels().length ? '' : 'is-empty',attrs:{"alternative":""}},[(_vm.is1stLevelStakeholdersMode)?_vm._l((_vm.getCardsByStakeholder()),function(value,key){return _c('TableListCard',{key:`superset-${_vm.aim.id}-stakeholder-${key}`,attrs:{"superset":{
        criterion: _vm.criterionId,
        aim: _vm.aim.id,
        alternative: _vm.alternativeId,
        subOption: _vm.subOptionId,
        stakeholder: Number(key),
      }}})}):_vm._l((_vm.getLabels()),function(label,index){return _c('TableListCard',{key:`superset-${label.property}-${label.value}-${index}`,attrs:{"superset":{
        criterion: _vm.criterionId,
        aim: _vm.aim.id,
        alternative: _vm.alternativeId,
        subOption: _vm.subOptionId,
        property: label.property,
        value: label.value,
      }}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }